import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { Markdown } from "@tiptap/markdown";
import { Table, TableRow } from "@tiptap/extension-table";
import Image from "@tiptap/extension-image";

import { ReadOnlyFirstColumnCell } from "components/TipTapEditorPlugins/ReadOnlyFirstColumnCell";

import { ReadOnlyTableHeader } from "components/TipTapEditorPlugins/ReadyOnlyTableHeader";

export const ReadOnlyEditor = ({ content }) => {
  const editor = useEditor(
    {
      extensions: [
        StarterKit,
        Table,
        Image,
        TableRow,
        ReadOnlyTableHeader,
        ReadOnlyFirstColumnCell,
        Markdown
      ],
      editable: false,
      contentType: "markdown" as const,
      content: content
    },
    [content]
  );

  return <EditorContent editor={editor} />;
};
